import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
  Tbody,
  Tr,
  Td,
  TableContainer,
  Table,
  Thead,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  FormControl,
  FormLabel,
  Switch,
} from "@chakra-ui/react";
import React, { memo, useEffect, useState } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import IconCheck from "../../../assets/images/booking/check-circle.svg";
import IconRed from "../../../assets/images/booking/x-red.svg";
import { formatTableValue } from "../formatTable";
import toast from "react-hot-toast";
import { lockingCall } from "../../../api/locking";
import { lockingHistoryCall } from "../../../api/lockingHistory";
import { formatDateDb } from "../../../utils/tools";
import { lockingParticipantCall } from "../../../api/lockingParticipant";
import { formatNumber, formatPriceUS } from "../../../utils/utils";
import { lockingRelativeParticipantCall } from "../../../api/lockingRelativeParticipant";
import { commissionCall } from "../../../api/commission";
import { saleOpeningEventMechanismParametersCall } from "../../../api/saleOpeningEventMechanismParameters";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const FormProvisionalInfo = memo(
  ({ isOpen, onClose, defaultValues, refetch }) => {
    const [historyBooking, setHistoryBooking] = useState(null);
    const [locking, setLocking] = useState(null);
    const [lockingRelativeParticipant, setLockingRelativeParticipant] =
      useState([]);
    const [openIndex, setOpenIndex] = useState([]);
    const [stepsCommission, setStepsCommission] = useState([]);
    const [kRate, setKRate] = useState(0);

    const getStepsCommission = async (lockingId) => {
      const data = await commissionCall.getStepByLockingId(lockingId);

      if (data) {
        setStepsCommission(data);
      }
    };

    useEffect(() => {
      if (stepsCommission.length > 0) {
        setOpenIndex(stepsCommission.map((_, idx) => idx));
      }
    }, [stepsCommission]);

    const getLocking = async (lockingId) => {
      const locking = await lockingCall.get(lockingId);

      if (locking) {
        setLocking(locking);

        if (lockingId && locking?.confirmCommissionStatus === "APPROVED") {
          getStepsCommission(lockingId);
        }

        if (locking?.saleOpeningEventId) {
          fectchDataSaleOpeningEventMechanismParameters(
            locking?.saleOpeningEventId,
          );
        }
      }
    };

    const fectchDataSaleOpeningEventMechanismParameters = async (
      idSaleOpenEvent,
    ) => {
      try {
        const data =
          await saleOpeningEventMechanismParametersCall.listBySaleOpeningEvent(
            idSaleOpenEvent,
          );

        const minKRate = Array.isArray(data)
          ? data.reduce((min, item) => {
              const value = Number(item?.kRate);

              if (!Number.isFinite(value)) return min;

              return min === null ? value : Math.min(min, value);
            }, null)
          : null;

        setKRate(minKRate ?? 0);
      } catch (error) {
        console.log("Lỗi khi fetch dữ liệu quản lý hệ số k");
        setKRate(0);
      }
    };

    useEffect(() => {
      //lấy ra thông tin locking
      if (defaultValues?.id) {
        getLocking(defaultValues?.id);
      }

      // lấy ra nhân viên tham gia giao dịch
      if (defaultValues?.id) {
        const fetchData = async () => {
          try {
            const participants =
              await lockingRelativeParticipantCall.getAttendanceManager(
                defaultValues?.id,
              );

            if (participants?.items) {
              let mappedData = null;
              if (participants?.items) {
                mappedData = participants?.items.map((item) => ({
                  fullName: item?.fullName || "",
                  interpretation: item?.interpretation || "",
                  fullNameRelative: item?.fullNameRelative || "",
                  workingDayData: item?.workingDays || "0",
                  isBrokerDebtCertificateData:
                    item?.isBrokerDebtCertificate || false,
                  amountHeldData: item?.amountHeld || "0",
                }));
              }
              setLockingRelativeParticipant(mappedData);
            }
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
        fetchData();
      }
      // lấy ra thông tin nhân viên tham gia

      //
      if (defaultValues?.id) {
        if (
          defaultValues?.status === "APPROVED" ||
          defaultValues?.status === "REJECTED"
        ) {
          const fetchDataBookingHistory = async () => {
            try {
              const data = await lockingHistoryCall.getHistoryLocking(
                defaultValues?.id,
              );

              setHistoryBooking(null);
              if (data?.items) {
                setHistoryBooking(data?.items[0]);
              }
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          };
          fetchDataBookingHistory();
        }
      }
    }, [isOpen]);

    const handleOpenIndex = (indexs) => {
      setOpenIndex(indexs);
    };

    const submitStatus = async (status) => {
      const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
      const dataFormat = {
        status: status,
      };

      try {
        await lockingCall.approve(defaultValues?.id, dataFormat);
        refetch();
        onClose();
        toast.success("Cập nhập trạng thái thành công");
      } catch (error) {
        console.error("Error:", error);
        toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
      }
      toast.dismiss(toastEdit);
    };

    const dataTable = {
      headers: [
        {
          label: "Tên nhân viên",
          key: "fullName",
        },
        {
          label: "Chức vụ",
          key: "interpretation",
        },
        {
          label: "CTV",
          key: "fullNameRelative",
        },
        {
          label: "Ngày công",
          key: "workingDays",
        },
        {
          label: "Đã có CCMG",
          key: "isBrokerDebtCertificate",
        },
        {
          label: "Số tiền CCMG tạm giữ",
          key: "amountHeld",
        },
      ],
      data: lockingRelativeParticipant,
    };

    const roundTo4 = (num) => Math.round(num * 10000) / 10000;

    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          backgroundColor="var(--color-main)"
          borderRadius={"16px"}
          position={"relative"}
          w={"100%"}
          maxW={"1024px"}
        >
          <Box
            paddingBottom={"80px"}
            h={"86.5vh"}
            w={"100%"}
            overflowY={"scroll"}
            sx={{
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
              "&::-moz-scrollbar": {
                width: "4px",
              },
              "&::-moz-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
            }}
          >
            <Box margin={"0 auto"} p={"24px 40px"}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"18px"}
                fontWeight={"600"}
              >
                Chi tiết phí dịch vụ tạm tính
              </Text>
              <Box>
                {/* Thông tin bước 1 */}
                <Box mt={"24px"}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Thông tin nhân viên tham gia giao dịch
                  </Text>
                  <Box
                    background={"var(--fill-avatar)"}
                    mt={"16px"}
                    borderRadius={"8px"}
                  >
                    <TableContainer
                      w={"100%"}
                      maxH="calc(100vh - 350.5px)"
                      overflowY="auto"
                    >
                      <Table w={"100%"} variant="unstyled">
                        <Thead
                          position="sticky"
                          top="0"
                          zIndex="1"
                          w={"100%"}
                          h={"41px"}
                          color="white"
                          fontWeight="400"
                          backgroundColor="#F9FAFD"
                          borderBottom={"1px solid var(--bg-line-employee)"}
                        >
                          <Tr h={{ base: "41px" }}>
                            {dataTable.headers.map((e, index) => {
                              let width = "auto";
                              let textAlign = "auto";
                              if (e.key === "employee") {
                                width = "2%";
                                textAlign = "start";
                              } else if (e.key === "employeeJobTitle") {
                                width = "5%";
                                textAlign = "start";
                              } else {
                                width = "10%";
                                textAlign = "center";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  key={index}
                                  border={"none"}
                                  color={"#51607B"}
                                  fontSize={{ base: "14px" }}
                                  w={width}
                                >
                                  <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        </Thead>
                        <Tbody w={"100%"} h={"100%"}>
                          {dataTable.data?.length > 0 ? (
                            dataTable.data?.map((e, rowIndex) => {
                              const keyValues = Object.keys(e);
                              return (
                                <Tr
                                  key={rowIndex}
                                  h={"44px"}
                                  backgroundColor={
                                    rowIndex % 2 === 0
                                      ? "var(--color-main)"
                                      : "var(--fill-avatar)"
                                  }
                                >
                                  {keyValues.map((keyvalue, index) => {
                                    let width = "auto";
                                    let widthText = "100%";
                                    let textAlign = "auto";
                                    let whiteSpace = "inherit";
                                    if (keyvalue === "employee") {
                                      width = "40%";
                                      textAlign = "start";
                                    } else if (
                                      keyvalue === "employeeJobTitle"
                                    ) {
                                      width = "40%";
                                      textAlign = "start";
                                    } else {
                                      width = "20%";
                                      textAlign = "center";
                                    }
                                    return (
                                      <Td
                                        p={"16px 16px 8px 16px"}
                                        w={width}
                                        key={index}
                                      >
                                        <Box
                                          fontSize={{ base: "14px" }}
                                          lineHeight={"19.6px"}
                                          textAlign={"start"}
                                          fontWeight={500}
                                          color={"var(--color-info-employee)"}
                                          w={widthText}
                                          whiteSpace={whiteSpace}
                                          overflow="hidden"
                                          textOverflow="ellipsis"
                                          display="-webkit-box"
                                          sx={{
                                            WebkitLineClamp: "2",
                                            WebkitBoxOrient: "vertical",
                                          }}
                                        >
                                          {formatTableValue(
                                            e[keyvalue],
                                            keyvalue,
                                          )}
                                        </Box>
                                      </Td>
                                    );
                                  })}
                                </Tr>
                              );
                            })
                          ) : (
                            <Tr>
                              <Td
                                colSpan={dataTable.headers.length}
                                textAlign="center"
                                padding={"40px 0"}
                              >
                                Không có dữ liệu
                              </Td>
                            </Tr>
                          )}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>

                {/* Thông tin bước 2 */}
                <Box mt={"24px"}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Thông tin giao dịch
                  </Text>
                  <Box flex={1}>
                    <Box>
                      <Box
                        background={"var(--fill-avatar)"}
                        p={"16px 24px 16px 16px"}
                        mt={"13px"}
                        borderRadius={"8px"}
                      >
                        {(defaultValues?.saleOpeningEvent ||
                          defaultValues?.booking) && (
                          <Flex gap={"27px"} mb={"16px"}>
                            {defaultValues?.booking && (
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Mã booking
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {defaultValues?.booking || ""}
                                </Text>
                              </Box>
                            )}
                          </Flex>
                        )}
                        <Flex gap={"27px"}>
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Người tạo locking
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {defaultValues?.nameBooker || ""}
                            </Text>
                          </Box>
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Ngày tạo locking
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {defaultValues?.createdAt || ""}
                            </Text>
                          </Box>
                        </Flex>
                        <Flex mt={"16px"} gap={"27px"}>
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Dự án
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {defaultValues?.project || ""}
                            </Text>
                          </Box>
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Mã sản phẩm
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {/* {defaultValues?.apartment || ""} */}
                              {`${defaultValues?.codeApartment || ""} ${
                                defaultValues?.apartment
                                  ? `(${defaultValues?.apartment})`
                                  : ""
                              }`}
                            </Text>
                          </Box>
                        </Flex>
                        <Flex mt={"16px"} gap={"27px"}>
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Hệ số K
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {`${roundTo4(Number(kRate))}`}
                            </Text>
                          </Box>
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Giá tính phí dịch vụ tạm tính
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {`${formatNumber(
                                Number(
                                  locking?.apartment
                                    ?.estimatedServiceFeePrice || 0,
                                ),
                              )} VNĐ`}
                            </Text>
                          </Box>
                        </Flex>

                        <Flex mt={"16px"} gap={"27px"}>
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Ngày khách hàng chuyển tiền / ngày cọc
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {formatDateDb(
                                locking?.transactionDate ||
                                  locking?.bookingTime ||
                                  "",
                              )}
                            </Text>
                          </Box>
                        </Flex>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                {/* Thông tin bước 3 */}
                <Box mt={"20px"}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Thông tin xác nhận phí dịch vụ
                  </Text>
                  <Box
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    mt={"16px"}
                    borderRadius={"8px"}
                  >
                    <Box w={"100%"}>
                      <StepCommissionData
                        lockingId={locking?._id}
                        locking={locking}
                        getLocking={getLocking}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              position={"absolute"}
              w={"100%"}
              bottom={"0"}
              bg={"var(--color-main)"}
              borderTop={"0.5px solid var(--bg-line-employee)"}
              borderRadius={"0px 0px 16px 16px"}
              zIndex={3}
            >
              {(defaultValues?.status === "NEW" ||
                defaultValues?.status === "EDITING") && (
                <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                  <Button
                    p={"13px 20px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-option-employee-hover)"}
                    borderRadius={"8px"}
                    border={"1px solid var(--color-option-employee-hover)"}
                    bg={"var(--color-main)"}
                    onClick={() => submitStatus("REJECTED")}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                  >
                    Không duyệt
                  </Button>
                  <Button
                    w={"133px"}
                    p={"13px 20px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-main)"}
                    borderRadius={"8px"}
                    bg={"var(--color-option-employee-hover)"}
                    onClick={() => submitStatus("APPROVED")}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                  >
                    Duyệt
                  </Button>
                </Flex>
              )}
            </Box>
          </Box>
        </ModalContent>
      </Modal>
    );
  },
);

const StepCommissionData = memo(({ lockingId, locking, getLocking }) => {
  const [calculateCommissionInfo, setCalculateCommissionInfo] = useState({});
  const [checkedSwitch, setCheckedSwitch] = useState(true);
  const [relativeParticipant, setRelativeParticipant] = useState([]);
  const [saleBlockManagers, setSaleBlockManagers] = useState([]);
  const [saleAreaManagers, setSaleAreaManagers] = useState([]);
  const [referrals, setReferrals] = useState([]);
  const [managers, setManagers] = useState([]);
  const [finalEmployees, setFinalEmployees] = useState([]);
  const [totalData, setTotalData] = useState({});
  const [totalFinalServiceFee, setTotalFinalServiceFee] = useState({
    commissionPrice: 0,
    certificateOrDeposit: 0,
    accountingFromPreviousPeriodOrAdvance: 0,
    remainingRevenueAfterAccounting: 0,
    personalIncomeTax: 0,
    remainingRevenueAfterTax: 0,
    bonus: 0,
  });
  const [data, setData] = useState(null);
  console.log({ data });

  const getFormData = async (id) => {
    try {
      const data = await lockingCall.getEstimateCommission(id);

      if (data) setData(data);

      if (data?.referralsForm?.checkedSwitch !== null) {
        setCheckedSwitch(data?.referralsForm?.checkedSwitch);
      }
      setCalculateCommissionInfo(data);

      // relativeParticipantForm
      if (data?.relativeParticipantForm?.list) {
        setRelativeParticipant(data.relativeParticipantForm.list);
      }
      if (data?.relativeParticipantForm?.totals) {
        const {
          totalRelativeParticipantIncomePrice,
          totalRelativeParticipantCommissionPrice,
        } = data.relativeParticipantForm.totals;

        if (totalRelativeParticipantIncomePrice) {
          setTotalData((prev) => ({
            ...prev,
            totalRelativeParticipantIncomePrice: formatPriceUS(
              totalRelativeParticipantIncomePrice,
            ),
          }));
        }

        if (totalRelativeParticipantCommissionPrice) {
          setTotalData((prev) => ({
            ...prev,
            totalRelativeParticipantCommissionPrice: formatPriceUS(
              totalRelativeParticipantCommissionPrice,
            ),
          }));
        }
      }

      // saleBlockManagersForm
      if (data?.saleBlockManagersForm?.list) {
        setSaleBlockManagers(data.saleBlockManagersForm.list);
      }
      if (data?.saleBlockManagersForm?.totals) {
        const {
          totalSaleBlockManagerCommissionRate,
          totalSaleBlockManagerCommissionPrice,
        } = data.saleBlockManagersForm.totals;

        if (totalSaleBlockManagerCommissionRate) {
          setTotalData((prev) => ({
            ...prev,
            totalSaleBlockManagerCommissionRate: formatPriceUS(
              totalSaleBlockManagerCommissionRate,
            ),
          }));
        }

        if (totalSaleBlockManagerCommissionPrice) {
          setTotalData((prev) => ({
            ...prev,
            totalSaleBlockManagerCommissionPrice: formatPriceUS(
              totalSaleBlockManagerCommissionPrice,
            ),
          }));
        }
      }

      // saleAreaManagersForm
      if (data?.saleAreaManagersForm?.list) {
        setSaleAreaManagers(data.saleAreaManagersForm.list);
      }
      if (data?.saleAreaManagersForm?.totals) {
        const {
          totalSaleAreaManagerCommissionRate,
          totalSaleAreaManagerCommissionPrice,
        } = data.saleAreaManagersForm.totals;

        if (totalSaleAreaManagerCommissionRate) {
          setTotalData((prev) => ({
            ...prev,
            totalSaleAreaManagerCommissionRate: formatPriceUS(
              totalSaleAreaManagerCommissionRate,
            ),
          }));
        }

        if (totalSaleAreaManagerCommissionPrice) {
          setTotalData((prev) => ({
            ...prev,
            totalSaleAreaManagerCommissionPrice: formatPriceUS(
              totalSaleAreaManagerCommissionPrice,
            ),
          }));
        }
      }

      // referralsForm
      if (data?.referralsForm?.list) {
        setReferrals(data.referralsForm.list);
      }
      if (data?.referralsForm?.totals) {
        const { totalReferralsCommissionRate, totalReferralsCommissionPrice } =
          data.referralsForm.totals;

        if (totalReferralsCommissionRate) {
          setTotalData((prev) => ({
            ...prev,
            totalReferralsCommissionRate: formatPriceUS(
              totalReferralsCommissionRate,
            ),
          }));
        }

        if (totalReferralsCommissionPrice) {
          setTotalData((prev) => ({
            ...prev,
            totalReferralsCommissionPrice: formatPriceUS(
              totalReferralsCommissionPrice,
            ),
          }));
        }
      }

      // managersForm
      if (data?.managersForm?.list) {
        setManagers(data.managersForm.list);
      }
      if (data?.managersForm?.totals) {
        const { totalAllCommissionRate, totalAllCommissionPrice } =
          data.managersForm.totals;

        if (totalAllCommissionRate) {
          setTotalData((prev) => ({
            ...prev,
            totalAllCommissionRate: formatPriceUS(totalAllCommissionRate),
          }));
        }

        if (totalAllCommissionPrice) {
          setTotalData((prev) => ({
            ...prev,
            totalAllCommissionPrice: formatPriceUS(totalAllCommissionPrice),
          }));
        }
      }

      // finalEmployeesForm
      if (data?.finalEmployeesForm?.list) {
        setFinalEmployees(data.finalEmployeesForm.list);
      }
      if (data?.finalEmployeesForm?.totals) {
        setTotalFinalServiceFee(data.finalEmployeesForm.totals);
      }
    } catch (err) {
      console.error("getFormData error:", err);
    }
  };

  useEffect(() => {
    if (lockingId) {
      getFormData(lockingId);
    }
  }, [lockingId]);

  const roundTo4 = (num) => Math.round(num * 10000) / 10000;

  const businessCategoryCodeFormat = (workingDays = 0) => {
    if (Number(workingDays) < 15) {
      return "CVKD";
    } else if (Number(workingDays) >= 15) {
      return "CVKD Elite";
    } else return "-";
  };

  return (
    <Box>
      {data && (
        <>
          <Box w={"100%"} mt={"20px"}>
            <Text
              fontSize={"16px"}
              lineHeight={"19px"}
              fontWeight={"600"}
              color={"var(--color-header-employee)"}
              mb={"16px"}
            >
              Thông tin chung
            </Text>
            {/* 2 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Tỉ lệ nhận về (%)
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${
                    calculateCommissionInfo?.informationForm?.transactionRate ||
                    0
                  }%`}
                </Text>
              </Box>
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  TTDA (%)
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${
                    calculateCommissionInfo?.informationForm
                      ?.calculateCommissionRate || 0
                  }%`}
                </Text>
              </Box>
            </Flex>
            {/* 3 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Hệ số K
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${roundTo4(
                    Number(
                      calculateCommissionInfo?.informationForm?.kRate || 0,
                    ),
                  )}`}
                </Text>
              </Box>
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Giá tính PDV
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${formatNumber(
                    Number(
                      calculateCommissionInfo?.informationForm
                        ?.priceForCommission || 0,
                    ),
                  )} VNĐ`}
                </Text>
              </Box>
            </Flex>
            {/* 3 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Ngày công chuẩn
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${
                    calculateCommissionInfo?.informationForm
                      ?.standardWorkingDaysInMonth || 0
                  }`}
                </Text>
              </Box>
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Tỉ lệ TN MSH (Đi kèm K) (%)
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${roundTo4(
                    calculateCommissionInfo?.informationForm?.incomeRate || 0,
                  )}%`}
                </Text>
              </Box>
            </Flex>
            {/* 3 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Tỉ lệ TN sàn (%)
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${
                    calculateCommissionInfo?.informationForm
                      ?.platformIncomeRate || 0
                  }%`}
                </Text>
              </Box>
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Tỉ lệ PDV CVKD (%)
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${
                    calculateCommissionInfo?.informationForm
                      ?.salesCommissionRate || 0
                  }%`}
                </Text>
              </Box>
            </Flex>
            {/* 3 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Tỉ lệ PDV CVKD Elite (%)
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${
                    calculateCommissionInfo?.informationForm
                      ?.eliteSalesCommissionRate || 0
                  }%`}
                </Text>
              </Box>
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Số tiền TN sàn
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${formatNumber(
                    Number(
                      calculateCommissionInfo?.informationForm?.priceTNSan || 0,
                    ),
                  )} VNĐ`}
                </Text>
              </Box>
            </Flex>
          </Box>
          {/* Hệ số tính PDV */}
          <Box w={"100%"} mt={"40px"}>
            <Text
              fontSize={"16px"}
              lineHeight={"19px"}
              fontWeight={"600"}
              color="var(--color-option-employee-hover)"
              mb={"16px"}
            >
              Hệ số tính PDV
            </Text>
            <Box w={"100%"}>
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
                mb={"16px"}
              >
                Người giới thiệu DL
              </Text>
              {/* 4 */}
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"12px"}
                w={"100%"}
              >
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Số tiền hưởng
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {`${roundTo4(
                      Number(
                        calculateCommissionInfo?.informationForm
                          ?.displayReferralPrice || 0,
                      ),
                    )}`}
                  </Text>
                </Box>
                <Box flex={1}>
                  <FormControl
                    display="flex"
                    flexDirection={"column"}
                    alignItems="flex-start"
                  >
                    <FormLabel
                      lineHeight={"15px"}
                      mb={2}
                      fontSize={{ base: "12px" }}
                      fontWeight={400}
                      htmlFor="email-alerts"
                      color={"var(--color-label-employee)"}
                    >
                      Tự động tính toán theo số tiền hưởng
                    </FormLabel>
                    <Switch
                      checked={checkedSwitch}
                      defaultChecked={checkedSwitch}
                      disabled={true}
                    />
                  </FormControl>
                </Box>
              </Flex>
              {/* Giám đốc khối */}
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
                mb={"16px"}
              >
                Giám đốc khối
              </Text>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"12px"}
                w={"100%"}
              >
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Tỉ lệ PDV GDKDH (%)
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {`${
                      calculateCommissionInfo?.informationForm
                        ?.commissionRateBlockManagerDH || 0
                    }%`}
                  </Text>
                </Box>
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Tỉ lệ PDV GDKDT (%)
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {`${
                      calculateCommissionInfo?.informationForm
                        ?.commissionRateBlockManagerDT || 0
                    }%`}
                  </Text>
                </Box>
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Tỉ lệ PDV GDKCL (%)
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {`${
                      calculateCommissionInfo?.informationForm
                        ?.commissionRateBlockManagerCL || 0
                    }%`}
                  </Text>
                </Box>
              </Flex>
              {/* Giám đốc vùng */}
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
                mb={"16px"}
              >
                Giám đốc vùng
              </Text>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"12px"}
                w={"100%"}
              >
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Tỉ lệ PDV GDKDH (%)
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {`${
                      calculateCommissionInfo?.informationForm
                        ?.commissionRateAreaManagerDH || 0
                    }%`}
                  </Text>
                </Box>
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Tỉ lệ PDV GDKDT (%)
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {`${
                      calculateCommissionInfo?.informationForm
                        ?.commissionRateAreaManagerDT || 0
                    }%`}
                  </Text>
                </Box>
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Tỉ lệ PDV GDKCL (%)
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {`${
                      calculateCommissionInfo?.informationForm
                        ?.commissionRateAreaManagerCL || 0
                    }%`}
                  </Text>
                </Box>
              </Flex>
              {/* Tổng giám đốc */}
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
                mb={"16px"}
              >
                Tổng giám đốc
              </Text>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"12px"}
                w={"100%"}
              >
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Tỉ lệ PDV TGD (%)
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {`${
                      calculateCommissionInfo?.informationForm
                        ?.commissionRateGeneralDirector || 0
                    }%`}
                  </Text>
                </Box>
              </Flex>
            </Box>
          </Box>
          {/* Nhân viên tham gia */}
          {relativeParticipant && (
            <Box w="100%" mt="20px">
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color="var(--color-option-employee-hover)"
                mb={"16px"}
              >
                Nhân viên tham gia
              </Text>
              {relativeParticipant?.length > 0 ? (
                <Box>
                  {relativeParticipant.map((item, index) => {
                    return (
                      <Box key={item.employeeId + "_" + index}>
                        <Text
                          color={"var(--color-header-employee)"}
                          fontSize={"14px"}
                          fontWeight={"600"}
                          mb={"12px"}
                        >
                          {item?.interpretation
                            ? item?.interpretation
                            : !item?.isCollaborator
                              ? "Người bán chính"
                              : "CTV"}{" "}
                          {`(${businessCategoryCodeFormat(item?.workingDays)})`}
                        </Text>
                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"flex-start"}
                          gap={"27px"}
                          mb={"12px"}
                          w={"100%"}
                        >
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Nhân viên tham gia
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {`${item?.employeeObject?.fullName || ""}`}
                            </Text>
                          </Box>
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Tỉ lệ (%)
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {`${item?.commissionRate || ""}%`}
                            </Text>
                          </Box>
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Ngày công
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {`${item?.workingDays || ""}`}
                            </Text>
                          </Box>
                        </Flex>
                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"flex-start"}
                          gap={"27px"}
                          mb={"12px"}
                          w={"100%"}
                        >
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Số tiền TN MSH (Đi kèm K)
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {`${formatPriceUS(
                                Number(item?.incomePrice || 0),
                              )} VNĐ`}
                            </Text>
                          </Box>
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Số tiền TN sàn
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {`${formatPriceUS(
                                Number(item?.platformIncomePrice || 0),
                              )} VNĐ`}
                            </Text>
                          </Box>
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Số tiền PDV CVKD
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {`${formatPriceUS(
                                Number(item?.salesCommissionPrice || 0),
                              )} VNĐ`}
                            </Text>
                          </Box>
                        </Flex>
                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"flex-start"}
                          gap={"27px"}
                          mb={"12px"}
                          w={"100%"}
                        >
                          <Box flex={"1"}>
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Số tiền PDV CVKD Elite
                            </Text>
                            <Text
                              color={"var(--color-option-employee)"}
                              fontSize={"14px"}
                              fontWeight={"500"}
                              mt={"8px"}
                            >
                              {`${formatPriceUS(
                                Number(item?.eliteSalesCommissionPrice || 0),
                              )} VNĐ`}
                            </Text>
                          </Box>
                        </Flex>
                      </Box>
                    );
                  })}
                  <Box
                    w={"full"}
                    border={"0.5px solid var(--color-option-employee-hover)"}
                    my={3}
                  ></Box>
                  {/* Tổng */}
                  <Text
                    fontSize={"14px"}
                    lineHeight={"19px"}
                    fontWeight={"600"}
                    color={"var(--color-header-employee)"}
                    mb={"16px"}
                  >
                    Tổng PDV nhân viên
                  </Text>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"12px"}
                    w={"100%"}
                  >
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Tổng TN
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${
                          totalData?.totalRelativeParticipantIncomePrice || 0
                        } VNĐ`}
                      </Text>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Tổng PDV
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${
                          totalData?.totalRelativeParticipantCommissionPrice ||
                          0
                        } VNĐ`}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              ) : (
                <Text color="red">Không có nhân viên tham gia</Text>
              )}
            </Box>
          )}
          {/* Giám đốc khối tham gia */}
          {saleBlockManagers && (
            <Box w="100%" mt="20px">
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color="var(--color-option-employee-hover)"
                mb={"16px"}
              >
                Giám đốc khối tham gia
              </Text>
              {saleBlockManagers?.length > 0 ? (
                <Box>
                  {saleBlockManagers.map((participant, managerIndex) => {
                    return (
                      <Box key={participant.employeeId + "_" + managerIndex}>
                        <Box mt="20px">
                          {participant?.employee?.fullName && (
                            <Flex gap={1}>
                              <Text
                                fontSize={{ base: "12px" }}
                                color={"red"}
                                lineHeight={"15px"}
                              >
                                *
                              </Text>
                              <Text
                                fontSize={"14px"}
                                lineHeight={"19px"}
                                fontWeight={"500"}
                                color={"var(--color-header-employee)"}
                                mb={"16px"}
                              >
                                Người bán chính:{" "}
                                {participant?.employee?.fullName}
                              </Text>
                            </Flex>
                          )}
                          {participant?.commissionRate && (
                            <Flex gap={1}>
                              <Text
                                fontSize={{ base: "12px" }}
                                color={"red"}
                                lineHeight={"15px"}
                              >
                                *
                              </Text>
                              <Text
                                fontSize={"14px"}
                                lineHeight={"19px"}
                                fontWeight={"500"}
                                color={"var(--color-header-employee)"}
                                mb={"16px"}
                              >
                                Tỉ lệ:{" "}
                                {participant?.mainSellerCommissionRate ||
                                  participant?.commissionRate}{" "}
                                %
                              </Text>
                            </Flex>
                          )}
                          <Box
                            w={"full"}
                            border={
                              "0.5px solid var(--color-option-employee-hover)"
                            }
                            mb={3}
                          ></Box>
                        </Box>
                        {participant?.items?.map((item, itemIndex) => {
                          const title =
                            itemIndex === 0
                              ? "GDKDH"
                              : itemIndex === 1
                                ? "GDKDT"
                                : itemIndex === 2
                                  ? "GDKCL"
                                  : "CTV";
                          return (
                            <Box key={item.employeeId + "_" + itemIndex}>
                              <Box w={"100%"}>
                                <Text
                                  color={"var(--color-header-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"600"}
                                >
                                  {title
                                    ? title
                                    : item?.isCollaborator
                                      ? "Người bán chính"
                                      : "CTV"}
                                </Text>
                                {/* 3 */}
                                <Flex
                                  justifyContent={"space-between"}
                                  alignItems={"flex-start"}
                                  gap={"27px"}
                                  mb={"12px"}
                                  w={"100%"}
                                ></Flex>
                                {/* 4 */}
                                {/* 5 */}
                                <Flex
                                  justifyContent={"space-between"}
                                  alignItems={"center"}
                                  gap={"27px"}
                                  mb={"12px"}
                                  w={"100%"}
                                >
                                  <Box flex={"1"}>
                                    <Text
                                      color={"var(--color-label-employee)"}
                                      fontSize={"12px"}
                                    >
                                      Nhân viên tham gia
                                    </Text>
                                    <Text
                                      color={"var(--color-option-employee)"}
                                      fontSize={"14px"}
                                      fontWeight={"500"}
                                      mt={"8px"}
                                    >
                                      {`${item?.employeeObject?.fullName || ""}`}
                                    </Text>
                                  </Box>
                                  <Box flex={"1"}>
                                    <Text
                                      color={"var(--color-label-employee)"}
                                      fontSize={"12px"}
                                    >
                                      Tỉ lệ (%)
                                    </Text>
                                    <Text
                                      color={"var(--color-option-employee)"}
                                      fontSize={"14px"}
                                      fontWeight={"500"}
                                      mt={"8px"}
                                    >
                                      {`${item?.commissionRate || ""}%`}
                                    </Text>
                                  </Box>
                                  <Box flex={"1"}>
                                    <Text
                                      color={"var(--color-label-employee)"}
                                      fontSize={"12px"}
                                    >
                                      Ngày công
                                    </Text>
                                    <Text
                                      color={"var(--color-option-employee)"}
                                      fontSize={"14px"}
                                      fontWeight={"500"}
                                      mt={"8px"}
                                    >
                                      {`${item?.workingDays || "0"}`}
                                    </Text>
                                  </Box>
                                  <Box flex={"1"}>
                                    <Text
                                      color={"var(--color-label-employee)"}
                                      fontSize={"12px"}
                                    >
                                      Số tiền
                                    </Text>
                                    <Text
                                      color={"var(--color-option-employee)"}
                                      fontSize={"14px"}
                                      fontWeight={"500"}
                                      mt={"8px"}
                                    >
                                      {`${formatPriceUS(
                                        Number(item?.commissionPrice || "0"),
                                      )} VNĐ`}
                                    </Text>
                                  </Box>
                                </Flex>
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    );
                  })}
                  <Box
                    w={"full"}
                    border={"0.5px solid var(--color-option-employee-hover)"}
                    my={3}
                  ></Box>
                  {/* Tổng */}
                  <Text
                    fontSize={"14px"}
                    lineHeight={"19px"}
                    fontWeight={"600"}
                    color={"var(--color-header-employee)"}
                    mb={"16px"}
                  >
                    Tổng PDV giám đốc khối
                  </Text>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"12px"}
                    w={"100%"}
                  >
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Tổng tỉ lệ PDV (%)
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${totalData?.totalSaleBlockManagerCommissionRate || 0}%`}
                      </Text>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Tổng PDV
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${
                          totalData?.totalSaleBlockManagerCommissionPrice || 0
                        } VNĐ`}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              ) : (
                <Text color="red">Không có giám đốc khối tham gia</Text>
              )}
            </Box>
          )}
          {/* Giám đốc vùng tham gia */}
          {saleAreaManagers && (
            <Box w="100%" mt="20px">
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color="var(--color-option-employee-hover)"
                mb={"16px"}
              >
                Giám đốc vùng tham gia
              </Text>
              {saleAreaManagers?.length > 0 ? (
                <Box>
                  {saleAreaManagers.map((participant, managerIndex) => {
                    return (
                      <Box key={participant.employeeId + "_" + managerIndex}>
                        <Box mt="20px">
                          {participant?.employee?.fullName && (
                            <Flex gap={1}>
                              <Text
                                fontSize={{ base: "12px" }}
                                color={"red"}
                                lineHeight={"15px"}
                              >
                                *
                              </Text>
                              <Text
                                fontSize={"14px"}
                                lineHeight={"19px"}
                                fontWeight={"500"}
                                color={"var(--color-header-employee)"}
                                mb={"16px"}
                              >
                                Người bán chính:{" "}
                                {participant?.employee?.fullName}
                              </Text>
                            </Flex>
                          )}
                          {participant?.commissionRate && (
                            <Flex gap={1}>
                              <Text
                                fontSize={{ base: "12px" }}
                                color={"red"}
                                lineHeight={"15px"}
                              >
                                *
                              </Text>
                              <Text
                                fontSize={"14px"}
                                lineHeight={"19px"}
                                fontWeight={"500"}
                                color={"var(--color-header-employee)"}
                                mb={"16px"}
                              >
                                Tỉ lệ:{" "}
                                {participant?.mainSellerCommissionRate ||
                                  participant?.commissionRate}{" "}
                                %
                              </Text>
                            </Flex>
                          )}
                          <Box
                            w={"full"}
                            border={
                              "0.5px solid var(--color-option-employee-hover)"
                            }
                            mb={3}
                          ></Box>
                        </Box>
                        {participant?.items?.map((item, itemIndex) => {
                          const title =
                            itemIndex === 0
                              ? "GDKDH"
                              : itemIndex === 1
                                ? "GDKDT"
                                : itemIndex === 2
                                  ? "GDKCL"
                                  : "CTV";
                          return (
                            <Box key={item.employeeId + "_" + itemIndex}>
                              <Box w={"100%"}>
                                <Text
                                  color={"var(--color-header-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"600"}
                                >
                                  {title
                                    ? title
                                    : item?.isCollaborator
                                      ? "Người bán chính"
                                      : "CTV"}
                                </Text>
                                {/* 3 */}
                                <Flex
                                  justifyContent={"space-between"}
                                  alignItems={"flex-start"}
                                  gap={"27px"}
                                  mb={"12px"}
                                  w={"100%"}
                                ></Flex>
                                {/* 4 */}
                                <Flex
                                  justifyContent={"space-between"}
                                  alignItems={"center"}
                                  gap={"27px"}
                                  mb={"12px"}
                                  w={"100%"}
                                >
                                  <Box flex={"1"}>
                                    <Text
                                      color={"var(--color-label-employee)"}
                                      fontSize={"12px"}
                                    >
                                      Nhân viên tham gia
                                    </Text>
                                    <Text
                                      color={"var(--color-option-employee)"}
                                      fontSize={"14px"}
                                      fontWeight={"500"}
                                      mt={"8px"}
                                    >
                                      {`${item?.employeeObject?.fullName || ""}`}
                                    </Text>
                                  </Box>
                                  <Box flex={"1"}>
                                    <Text
                                      color={"var(--color-label-employee)"}
                                      fontSize={"12px"}
                                    >
                                      Tỉ lệ (%)
                                    </Text>
                                    <Text
                                      color={"var(--color-option-employee)"}
                                      fontSize={"14px"}
                                      fontWeight={"500"}
                                      mt={"8px"}
                                    >
                                      {`${item?.commissionRate || ""}%`}
                                    </Text>
                                  </Box>
                                  <Box flex={"1"}>
                                    <Text
                                      color={"var(--color-label-employee)"}
                                      fontSize={"12px"}
                                    >
                                      Ngày công
                                    </Text>
                                    <Text
                                      color={"var(--color-option-employee)"}
                                      fontSize={"14px"}
                                      fontWeight={"500"}
                                      mt={"8px"}
                                    >
                                      {`${item?.workingDays || "0"}`}
                                    </Text>
                                  </Box>
                                  <Box flex={"1"}>
                                    <Text
                                      color={"var(--color-label-employee)"}
                                      fontSize={"12px"}
                                    >
                                      Số tiền
                                    </Text>
                                    <Text
                                      color={"var(--color-option-employee)"}
                                      fontSize={"14px"}
                                      fontWeight={"500"}
                                      mt={"8px"}
                                    >
                                      {`${formatPriceUS(
                                        Number(item?.commissionPrice || "0"),
                                      )} VNĐ`}
                                    </Text>
                                  </Box>
                                </Flex>
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    );
                  })}
                  <Box
                    w={"full"}
                    border={"0.5px solid var(--color-option-employee-hover)"}
                    my={3}
                  ></Box>
                  {/* Tổng */}
                  <Text
                    fontSize={"14px"}
                    lineHeight={"19px"}
                    fontWeight={"600"}
                    color={"var(--color-header-employee)"}
                    mb={"16px"}
                  >
                    Tổng PDV giám đốc vùng
                  </Text>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"12px"}
                    w={"100%"}
                  >
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Tổng tỉ lệ PDV (%)
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${totalData?.totalSaleAreaManagerCommissionRate || 0}%`}
                      </Text>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Tổng PDV
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${
                          totalData?.totalSaleAreaManagerCommissionPrice || 0
                        } VNĐ`}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              ) : (
                <Text color="red">Không có giám đốc vùng tham gia</Text>
              )}
            </Box>
          )}
          {/* Người giới thiệu tham gia */}
          {referrals && (
            <Box w="100%" mt="40px">
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color="var(--color-option-employee-hover)"
                mb={"16px"}
              >
                Người GTDL tham gia
              </Text>
              {referrals?.length > 0 ? (
                <Box>
                  {referrals.map((item, index) => (
                    <Box key={item.employeeId + "_" + index}>
                      <Flex
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        gap={"27px"}
                        mb={"12px"}
                        w={"100%"}
                      >
                        <Box flex={"1"}>
                          <Text
                            color={"var(--color-label-employee)"}
                            fontSize={"12px"}
                          >
                            Nhân viên tham gia
                          </Text>
                          <Text
                            color={"var(--color-option-employee)"}
                            fontSize={"14px"}
                            fontWeight={"500"}
                            mt={"8px"}
                          >
                            {`${item?.employeeObject?.fullName || item?.employee?.fullName || ""}`}
                          </Text>
                        </Box>
                        <Box flex={"1"}>
                          <Text
                            color={"var(--color-label-employee)"}
                            fontSize={"12px"}
                          >
                            Tỉ lệ (%)
                          </Text>
                          <Text
                            color={"var(--color-option-employee)"}
                            fontSize={"14px"}
                            fontWeight={"500"}
                            mt={"8px"}
                          >
                            {`${item?.commissionRate || ""}%`}
                          </Text>
                        </Box>
                        <Box flex={"1"}>
                          <Text
                            color={"var(--color-label-employee)"}
                            fontSize={"12px"}
                          >
                            Số tiền
                          </Text>
                          <Text
                            color={"var(--color-option-employee)"}
                            fontSize={"14px"}
                            fontWeight={"500"}
                            mt={"8px"}
                          >
                            {`${formatPriceUS(
                              Number(item?.commissionPrice || "0"),
                            )} VNĐ`}
                          </Text>
                        </Box>
                      </Flex>
                    </Box>
                  ))}
                  <Box
                    w={"full"}
                    border={"0.5px solid var(--color-option-employee-hover)"}
                    my={3}
                  ></Box>
                  {/* Tổng */}
                  <Text
                    fontSize={"14px"}
                    lineHeight={"19px"}
                    fontWeight={"600"}
                    color={"var(--color-header-employee)"}
                    mb={"16px"}
                  >
                    Tổng PDV người GTDL
                  </Text>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"12px"}
                    w={"100%"}
                  >
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Tổng PDV
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${totalData?.totalReferralsCommissionPrice || 0} VNĐ`}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              ) : (
                <Text color="red">Không có người GTDL tham gia</Text>
              )}
            </Box>
          )}
          {/* Giám đốc tham gia */}
          {managers && (
            <Box w="100%" mt="40px">
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color="var(--color-option-employee-hover)"
                mb={"16px"}
              >
                Giám đốc tham gia
              </Text>
              {managers?.length > 0 ? (
                <Box>
                  {managers.map((item, index) => (
                    <Box key={item.employeeId + "_" + index}>
                      <Flex
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        gap={"27px"}
                        mb={"12px"}
                        w={"100%"}
                      >
                        <Box flex={"1"}>
                          <Text
                            color={"var(--color-label-employee)"}
                            fontSize={"12px"}
                          >
                            Nhân viên tham gia
                          </Text>
                          <Text
                            color={"var(--color-option-employee)"}
                            fontSize={"14px"}
                            fontWeight={"500"}
                            mt={"8px"}
                          >
                            {`${item?.employeeObject?.fullName || ""}`}
                          </Text>
                        </Box>
                        <Box flex={"1"}>
                          <Text
                            color={"var(--color-label-employee)"}
                            fontSize={"12px"}
                          >
                            Tỉ lệ (%)
                          </Text>
                          <Text
                            color={"var(--color-option-employee)"}
                            fontSize={"14px"}
                            fontWeight={"500"}
                            mt={"8px"}
                          >
                            {`${item?.commissionRate || ""}%`}
                          </Text>
                        </Box>
                        <Box flex={"1"}>
                          <Text
                            color={"var(--color-label-employee)"}
                            fontSize={"12px"}
                          >
                            Số tiền
                          </Text>
                          <Text
                            color={"var(--color-option-employee)"}
                            fontSize={"14px"}
                            fontWeight={"500"}
                            mt={"8px"}
                          >
                            {`${formatPriceUS(
                              Number(item?.commissionPrice || "0"),
                            )} VNĐ`}
                          </Text>
                        </Box>
                      </Flex>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Text color="red">Không có giám đốc tham gia</Text>
              )}
            </Box>
          )}
          {relativeParticipant && (
            <Box w="100%" mt="40px">
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color="var(--color-option-employee-hover)"
                mb={"16px"}
              >
                Tổng cộng PDV
              </Text>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"12px"}
                w={"100%"}
              >
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Tỉ lệ (%)
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {`${totalData?.totalAllCommissionRate || ""}%`}
                  </Text>
                </Box>
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Tổng PDV
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {`${totalData?.totalAllCommissionPrice || "0"} VNĐ`}
                  </Text>
                </Box>
              </Flex>
            </Box>
          )}
          {finalEmployees && (
            <Box w="100%" mt="40px">
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color="var(--color-option-employee-hover)"
                mb={"16px"}
              >
                Phí giao dịch theo căn
              </Text>
              {finalEmployees?.length > 0 ? (
                <Box>
                  {finalEmployees.map((item, index) => {
                    return (
                      <Box key={item.employeeId + "_" + index}>
                        <Box w={"100%"}>
                          <Text
                            color={"var(--color-header-employee)"}
                            fontSize={"14px"}
                            fontWeight={"600"}
                          >
                            {"Người tham gia"}
                          </Text>
                          {/* 3 */}
                          <Flex
                            justifyContent={"space-between"}
                            alignItems={"flex-start"}
                            gap={"27px"}
                            mb={"12px"}
                            w={"100%"}
                          ></Flex>
                          {/* 4 */}
                          {/* 5 */}
                          <Flex
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            mb={"12px"}
                            w={"100%"}
                            flexWrap={"wrap"}
                          >
                            <Flex
                              justifyContent={"space-between"}
                              alignItems={"flex-start"}
                              gap={"27px"}
                              mb={"12px"}
                              w={"100%"}
                              flexWrap={"wrap"}
                            >
                              <Box flex={1}>
                                <Box flex={"1"}>
                                  <Text
                                    color={"var(--color-label-employee)"}
                                    fontSize={"12px"}
                                  >
                                    Nhân viên tham gia
                                  </Text>
                                  <Text
                                    color={"var(--color-option-employee)"}
                                    fontSize={"14px"}
                                    fontWeight={"500"}
                                    mt={"8px"}
                                  >
                                    {`${item?.employeeObject?.fullName || ""}`}
                                  </Text>
                                </Box>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Số tiền
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {`${formatPriceUS(
                                    Number(item?.commissionPrice || "0"),
                                  )} VNĐ`}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Chứng chỉ/ ký quỹ
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {`${formatPriceUS(
                                    Number(item?.certificateOrDeposit || "0"),
                                  )} VNĐ`}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  KT do đã ĐK kì trước/Đã tạm ứng/KT khác
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {`${formatPriceUS(
                                    Number(
                                      item?.accountingFromPreviousPeriodOrAdvance ||
                                        "0",
                                    ),
                                  )} VNĐ`}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex
                              justifyContent={"space-between"}
                              alignItems={"flex-start"}
                              gap={"27px"}
                              mb={"12px"}
                              w={"100%"}
                              flexWrap={"wrap"}
                            >
                              <Box flex={1}>
                                <Box flex={"1"}>
                                  <Text
                                    color={"var(--color-label-employee)"}
                                    fontSize={"12px"}
                                  >
                                    PDV còn lại sau KT
                                  </Text>
                                  <Text
                                    color={"var(--color-option-employee)"}
                                    fontSize={"14px"}
                                    fontWeight={"500"}
                                    mt={"8px"}
                                  >
                                    {`${formatPriceUS(
                                      Number(
                                        item?.remainingRevenueAfterAccounting ||
                                          "0",
                                      ),
                                    )} VNĐ`}
                                  </Text>
                                </Box>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Thuế TNCN
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {`${formatPriceUS(
                                    Number(item?.personalIncomeTax || "0"),
                                  )} VNĐ`}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Thưởng nóng
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {`${formatPriceUS(
                                    Number(item?.bonus || "0"),
                                  )} VNĐ`}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  PDV còn lại sau thuế
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {`${formatPriceUS(
                                    Number(
                                      item?.remainingRevenueAfterTax || "0",
                                    ),
                                  )} VNĐ`}
                                </Text>
                              </Box>
                            </Flex>
                          </Flex>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              ) : (
                <Text color="red">Không có người tham gia</Text>
              )}
            </Box>
          )}
          {finalEmployees && (
            <Box w="100%" mt="40px">
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color="var(--color-option-employee-hover)"
                mb={"16px"}
              >
                Tổng cộng
              </Text>
              <Box w={"100%"}>
                <Flex
                  justifyContent={"space-between"}
                  alignItems={"flex-start"}
                  gap={"27px"}
                  mb={"12px"}
                  w={"100%"}
                  flexWrap={"wrap"}
                >
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"12px"}
                    w={"100%"}
                    flexWrap={"wrap"}
                  >
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Số tiền
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${formatPriceUS(
                          Number(totalFinalServiceFee.commissionPrice || "0"),
                        )} VNĐ`}
                      </Text>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Chứng chỉ/ ký quỹ
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${formatPriceUS(
                          Number(
                            totalFinalServiceFee.certificateOrDeposit || "0",
                          ),
                        )} VNĐ`}
                      </Text>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        KT do đã ĐK kì trước/Đã tạm ứng/KT khác
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${formatPriceUS(
                          Number(
                            totalFinalServiceFee.accountingFromPreviousPeriodOrAdvance ||
                              "0",
                          ),
                        )} VNĐ`}
                      </Text>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        PDV còn lại sau KT
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${formatPriceUS(
                          Number(
                            totalFinalServiceFee.remainingRevenueAfterAccounting ||
                              "0",
                          ),
                        )} VNĐ`}
                      </Text>
                    </Box>
                  </Flex>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"12px"}
                    w={"100%"}
                    flexWrap={"wrap"}
                  >
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Thuế TNCN
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${formatPriceUS(
                          Number(totalFinalServiceFee.personalIncomeTax || "0"),
                        )} VNĐ`}
                      </Text>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Thưởng nóng
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${formatPriceUS(
                          Number(totalFinalServiceFee.bonus || "0"),
                        )} VNĐ`}
                      </Text>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        PDV còn lại sau thuế
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {`${formatPriceUS(
                          Number(
                            totalFinalServiceFee.remainingRevenueAfterTax ||
                              "0",
                          ),
                        )} VNĐ`}
                      </Text>
                    </Box>
                    <Box flex={"1"}></Box>
                  </Flex>
                </Flex>
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
});

export default FormProvisionalInfo;
